import type { SelfDescribingJson } from "@snowplow/browser-tracker"

export type SnowplowJobPayloadProps = {
  readonly jpmuid: string
  readonly jobAdId: number
  readonly placement: string
}

export function mapToSnowplowJobPayload({
  jobAdId,
  jpmuid,
  placement,
}: SnowplowJobPayloadProps): null | ReadonlyArray<SelfDescribingJson> {
  const jobTrackingContext = "website"
  const jobPayload = [
    {
      data: {
        context: jobTrackingContext,
        jobAdIds: [jobAdId],
        jpmuid,
        placement,
      },
      schema: "iglu:dk.jyllands-posten/jobad_impression/jsonschema/4-0-0",
    },
  ]
  return jobPayload
}
